var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document.associations.images && _vm.document.associations.images.length !== 0)?_c('div',{staticClass:"box no-print image-box"},[_c('gallery',{ref:"gallery",attrs:{"images":_vm.document.associations.images}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }